import 'src/globals.js';
import 'src/components.js';